import axios from 'axios';
import { setInterceptors } from './common/interceptors';

function createInstance() {
  // console.log('createInstance baseURL : ' + process.env.VUE_APP_API_URL);
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
}

// request header에 인증토큰이 필요한 api는 여기 태우자!
function createInstanceWithAuth(url) {
  const instance = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}${url}`,
  });
  // const consoleBaseURL = `${process.env.VUE_APP_API_URL}${url}`;
  // console.log('createInstanceWithAuth baseURL : ' + consoleBaseURL);
  return setInterceptors(instance);
}

/* ===================================================================== */
/* [ login ] */
export const loginProxy = createInstance();
export const loginProxyWithAuth = createInstanceWithAuth('');

/* [ mobile-api module ] */
export const elaMobileApi = createInstanceWithAuth('api/ela/');
export const fileMobileApi = createInstanceWithAuth('api/file/');

/* [ workup module ] */
// workup-emp
export const empProxy = createInstanceWithAuth('api/emp/');
export const empSearchProxy = createInstanceWithAuth('api/emp/search/');

// workup-org
export const orgInfoProxy = createInstanceWithAuth('api/org/info/');

// workup-pay
export const payStaProxy = createInstanceWithAuth('api/pay/sta/');

// workup-work
export const workCodeProxy = createInstanceWithAuth('api/work/code/');
export const workMainProxy = createInstanceWithAuth('api/work/main/');
export const workAnnualProxy = createInstanceWithAuth('api/work/annual/');
export const workAnnualProxyBody = createInstanceWithAuth('api/work/annual/');
export const workDailyProxy = createInstanceWithAuth('api/work/daily/');
export const workPsnlProxy = createInstanceWithAuth('api/work/psnl/');
export const workPsnlworkProxy = createInstanceWithAuth('api/work/psnlwork/');
export const workOrgProxy = createInstanceWithAuth('api/work/org/');
export const workApprovalProxy = createInstanceWithAuth('api/work/approval/');
export const workApprovalProxyBody =
  createInstanceWithAuth('api/work/approval/');
export const workConfigProxy = createInstanceWithAuth('api/work/config/');
export const workMobileStatusProxy = createInstanceWithAuth('api/work/status/');

// workup-ela
export const elaViewProxy = createInstanceWithAuth('api/ela/view/');
export const elaAppProxy = createInstanceWithAuth('api/ela/app/');
export const elaAppProxyBody = createInstanceWithAuth('api/ela/app/');
export const elaApiProxy = createInstanceWithAuth('api/ela/api/');
export const elaApiProxyBody = createInstanceWithAuth('api/ela/api/');

// workup-config
export const configProxy = createInstanceWithAuth('api/ncConfig/');

// workup-ncAuth
export const ncAuchProxy = createInstanceWithAuth('api/ncAuth/');
//export const ncAuchProxy = createInstance('ncAuth/');

// board
export const boardProxy = createInstanceWithAuth('api/board/');

//second authenticate
export const secondAuthenticateProxy = createInstanceWithAuth('');

//rd
export const rdProxy = createInstanceWithAuth('api/api/rd/');

//contract
export const contractProxy = createInstanceWithAuth('api/api/contract');

//sign upload /mobile/api/file/sign
export const signProxy = createInstanceWithAuth('api/file/sign');